import { render, staticRenderFns } from "./viewPemeriksa.vue?vue&type=template&id=71965aa4"
import script from "./viewPemeriksa.vue?vue&type=script&lang=js"
export * from "./viewPemeriksa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QCard,QCardSection})
